// Single source of truth for the backend base URL.
//
// Resolution order:
//   1. REACT_APP_API_BASE env var, baked in at build time by CRA.
//      Set this in each Render Static Site (staging/production) so the same
//      bundle can target different backends.
//   2. Fallback: localhost dev server when running on localhost, otherwise
//      the production WMS host. Preserves behaviour from before this var
//      existed, so unset envs keep working.
export const API_BASE: string =
    process.env.REACT_APP_API_BASE
    ?? (typeof window !== "undefined" && window.location.hostname === "localhost"
        ? "http://localhost:3001"
        : "https://wms.jlitrading.co.uk");
